export class FavoriteApiResult {
    static get ADDED() {
        return "added";
    }

    static get REMOVED() {
        return "removed";
    }

    static get ERROR() {
        return "failure";
    }
};


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/favorites/classes/favorites-api.ts